module.exports = __webpack_public_path__ + "static/media/fish-cooked.10b68839.svg";